import { AuthError } from '@juvare/platform-app/App';
// Only internal calls are allowed for file versions
export function onAuthGet() {
    throw new AuthError('Unauthorized');
}
export function onAuthList() {
    throw new AuthError('Unauthorized');
}
export function onAuthPost() {
    throw new AuthError('Unauthorized');
}
